<template lang="pug">
#landing.animated.fadeIn
  .top-wrapper(v-if="!whiteLabel")
    .top
      .logo
        img(:src="logoPath")
  section.slider-wrap
    .bg-landing
      //- canvas#skylogoPath
    //- #cny-rain1
    //- #cny-rain2
    //- #cny-rain3
      //- #euro-ribbon-rain
      //- #euro-ribbon-rain2
      //- #euro-ribbon-rain3
      //- #xmas-rain1
      //- #xmas-rain2
      //- #xmas-rain3
    #main-carousel.carousel.slide(data-ride="carousel")
      ol.carousel-indicators
        li.active(data-target="#main-carousel" data-slide-to="0")
        li(data-target="#main-carousel" data-slide-to="1")
        li(data-target="#main-carousel" data-slide-to="2")
        li(data-target="#main-carousel" data-slide-to="3")
        li(data-target="#main-carousel" data-slide-to="4")
        template(v-if="esports2")
          li(data-target="#main-carousel" data-slide-to="5")
      .carousel-inner
        //- #worldcup.carousel-item.worldcup.active
        //-   .banner-text
        //-     h1
        //-       img(src='https://r.myw0011001.com/mobile/landing/worldcup_title.png')
        //-     p
        //-       | {{ $t("message.banner11a") }}
        //-       br
        //-       | {{ $t("message.banner11b") }}
        //-       br
        //-       | {{ $t("message.banner11c") }}
        //-   .banner-image
        //-     img.img-fluid.animate-image(src='https://r.myw0011001.com/mobile/landing/banner-11-2.png?v=12')
        //-     img.img-fluid(src='https://r.myw0011001.com/mobile/landing/banner-11-1.png?v=12')
        #efight.carousel-item.efight.active
          .banner-text
            h1
              | {{ $t("message.banner6a") }}
              br
              | {{ $t("message.banner6b") }}
            p
              | {{ $t("message.banner6c") }}
          .banner-image
            img.img-fluid.animate-image(:src="getImage('banner-08-2.png')")
            img.img-fluid(:src="getImage('banner-08-1.png')")
        template(v-if="esports2")
          #efight2.carousel-item
            .banner-text
              h1
                | {{ $t("message.banner7a") }}
                br
                | {{ $t("message.banner7b") }}
              p
                | {{ $t("message.banner7c") }}
                br
                | {{ $t("message.banner7d") }}
            .banner-image
              img.img-fluid.animate-image(:src="getImage('banner-09-2.png')")
              img.img-fluid(:src="getImage('banner-09-1.png')")
        #sport.carousel-item
          .banner-text
            h1
              | {{ $t("message.banner1a") }}
              br
              | {{ $t("message.banner1b") }}
            p
              | {{ $t("message.banner1c") }}
          .banner-image
            img.img-fluid.animate-image(:src="getImage('banner-01-2.png')")
            img.img-fluid(:src="getImage('banner-01-1.png')")
        #casino.carousel-item.casino
          .banner-text
            h1
              | {{ $t("message.banner2a") }}
              br
              | {{ $t("message.banner2b") }}
            p
              | {{ $t("message.banner2c") }}
          .banner-image
            img.img-fluid.animate-image(:src="getImage('banner-02-2.png')")
            img.img-fluid(:src="getImage('banner-02-1.png')")
        #games.carousel-item.games
          .banner-text
            h1
              | {{ $t("message.banner3a") }}
              br
              | {{ $t("message.banner3b") }}
            p
              | {{ $t("message.banner3c") }}
          .banner-image
            img.img-fluid.animate-image(:src="getImage('banner-03-2.png')")
            img.img-fluid(:src="getImage('banner-03-1.png')")
        #live.carousel-item.live
          .banner-text
            h1
              | {{ $t("message.banner5a") }}
              br
              | {{ $t("message.banner5aa") }}
            p
              | {{ $t("message.banner5b") }}
              br
              | {{ $t("message.banner5c") }}
          .banner-image
            img.img-fluid.animate-image(:src="getImage('banner-05-2.png')")
            img.img-fluid(:src="getImage('banner-05-1.png')")
      a.carousel-control-prev(href="#main-carousel" role="button" data-slide="prev")
        span.carousel-control-prev-icon(aria-hidden="true")
        span.sr-only Previous
      a.carousel-control-next(href="#main-carousel" role="button" data-slide="next")
        span.carousel-control-next-icon(aria-hidden="true")
        span.sr-only Next
  loginModal(v-if="!whiteLabel")
  section.lobby-wrap
    .inner-wrap
      .lobbyinner
        .row
          .col-12.mobile
            .lobby-item
              .card-flip(data-toggle="modal" data-target="#login-modal")
                .front
                  .image-wrap
                    img(:src="getImage('sportsbook_mobile.jpg')")
                  .info
                    h1 {{ $t("ui.sportsbook").toUpperCase() }}
                .back
                  h3 {{ $t("ui.sportsbook").toUpperCase() }}
                  p
                    | {{ $t("message.bannersb") }}
                  .card-footer
                    button.btn(data-toggle="modal" data-target="#login-modal") {{ $t("ui.play_now") }}
          .col-6.col-md-4
            .lobby-item
              .card-flip(data-toggle="modal" data-target="#login-modal")
                .front
                  .image-wrap
                    img(:src="getImage('casino.jpg')")
                  .info
                    h1 {{ $t("ui.livecasino").toUpperCase() }}
                .back
                  h3 {{ $t("ui.livecasino").toUpperCase() }}
                  p
                    | {{ $t("message.bannerlc") }}
                    .card-footer
                      button.btn(data-toggle="modal" data-target="#login-modal") {{ $t("ui.play_now") }}
          .col-md-4.desktop
            .lobby-item.sport
              .card-flip(data-toggle="modal" data-target="#login-modal")
                .front
                  .image-wrap
                    img.desktop(:src="getImage('sportsbook.jpg')")
                  .info
                    h1 {{ $t("ui.sportsbook").toUpperCase() }}
                .back
                  h3 {{ $t("ui.sportsbook").toUpperCase() }}
                  p
                    | {{ $t("message.bannersb") }}
                  .card-footer
                    button.btn(data-toggle="modal" data-target="#login-modal") {{ $t("ui.play_now") }}
          .col-6.col-md-4
            .lobby-item
              .card-flip(data-toggle="modal" data-target="#login-modal")
                .front
                  .image-wrap
                    img(:src="getImage('games.jpg')")
                  .info
                    h1 {{ $t("ui.slots").toUpperCase() }}
                .back
                  h3 {{ $t("ui.slots").toUpperCase() }}
                  p
                    | {{ $t("message.bannersl") }}
                  .card-footer
                    button.btn(data-toggle="modal" data-target="#login-modal") {{ $t("ui.play_now") }}
      .join-us(v-if="!whiteLabel")
        h1 {{ $t("message.join_us1") }}
        p
          | {{ $t("message.join_us2") }}
        button.join-btn(data-toggle="modal" data-target="#login-modal") {{ $t("message.join_us3") }}
  section.feature-wrap
    .deco1
      img(:src="getImage('football.png')")
    .deco2
      img(:src="getImage('footballplayer.png')")
    .row.featureinner
      .col-12.col-md-6.feature-item
        .icon
          img(:src="getImage('feature_icon1.svg')")
        .feature-content
          h1 {{ $t("message.icon1a") }}
          p {{ $t("message.icon1b") }}
      .col-12.col-md-6.feature-item
        .icon
          img(:src="getImage('feature_icon2.svg')")
        .feature-content
          h1 {{ $t("message.icon2a") }}
          p {{ $t("message.icon2b") }}
    .row.featureinner
      .col-12.col-md-6.feature-item
        .icon
          img(:src="getImage('feature_icon3.svg')")
        .feature-content
          h1 {{ $t("message.icon3a") }}
          p {{ $t("message.icon3b") }}
      .col-12.col-md-6.feature-item
        .icon
          img(:src="getImage('feature_icon4.svg')")
        .feature-content
          h1 {{ $t("message.icon4a") }}
          p {{ $t("message.icon4b") }}
  footer.footer
    a.switch-desktop.mobile(v-if="!whiteLabel" :href="desktopUrl")
      img.desktop-icon(src='https://r.myw0011001.com/mobile/landing/desktop-mode.svg?v=12')
      button {{ $t("ui.switch_to_desktop") }}
    .license
      .image-wrap
        img(:src="getImage('license/01.png')")
      .image-wrap
        img(:src="getImage('license/02.png')")
      .image-wrap
        img(:src="getImage('license/03.png')")
      .image-wrap
        img(:src="getImage('license/04.png')")
      .image-wrap
        img(:src="getImage('license/05.png')")
      .image-wrap
        img(:src="getImage('license/06.png')")
      .image-wrap
        img(:src="getImage('license/07.png')")
      .image-wrap
        img(:src="getImage('license/08.png')")
    .tnc(v-if="!whiteLabel")
      .icon
        img(:src="getImage('18plus.svg')")
      .tnc-content
        h4 {{ $t("message.footer1a") }}
        p
          | {{ $t("message.footer1b", { "fvalue": this.brand }) }}
  .tutorial(v-if="!isStandalonePWA && !whiteLabel")
    //- .android.d-flex.align-items-center.justify-content-between(v-if="isAndroid")
    //-   //- a.d-flex.align-items-center.flex-grow-1(href="javascript:void(0);" data-toggle='modal' data-target='#android-homescreen-modal')
    //-   //- a.d-flex.align-items-center.flex-grow-1#addHomescreen(href="javascript:void(0);")
    //-   //-   img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon.svg?v=12')
    //-   //-   div Add WBET to home screen
    //-   a.d-flex.align-items-center.flex-grow-1#addHomescreen(href="javascript:void(0);")
    //-     template(v-if="brand == 'FOTBET'")
    //-       img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon_gs.svg')
    //-     template(v-else-if="brand == 'UBETT'")
    //-       img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon_ub.svg')
    //-     template(v-else)
    //-       img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon.svg')
    //-     div Add {{ brand }} to home screen
    //-   .remove(@click="close(0)")
    //-     i.fal.fa-times
    .ios(v-if="isIOS")
      .d-flex.align-items-start
        //- img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon.svg?v=12')
        template(v-if="brand == 'FOTBET'")
          img.icon(src='https://r.myw0011001.com/mobile/landing/fotbet_icon_512x512.png')
        template(v-else-if="brand == 'UBETT'")
          img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon_ub.svg')
        template(v-else)
          img.icon(src='https://r.myw0011001.com/mobile/landing/app_icon.svg')
        .flex-grow-1
          | {{ $t("ui.tutorial_tooltips") }}
      .link-wrapper.d-flex.justify-content-end
        a(href="javascropt:void(0);" data-toggle='modal' data-target='#ios-homescreen-modal')
          .mr-4
            i.fas.fa-play
            | &nbsp;{{ $t("ui.tutorial") }}
        div(@click="close(1)") {{ $t("ui.dismiss") }}

</template>

<script>
import config from "@/config";
import loginModal from "@/components/mobile/loginModal";

export default {
  components: {
    loginModal
  },
  data() {
    return {
      isStandalonePWA: false,
      isIOS: false,
      isAndroid: false,
      isWindows: false,
      isTimesUp: false
    }
  },
  computed: {
    logoPath() {
      return config.logoPath;
    },
    brand() {
      return config.brand;
    },
    desktopUrl() {
      const domain = window.location.hostname;
      return `https://${domain.replace("mv2.", "dv2.")}?view=desktop`;
    },
    whiteLabel() {
      return config.whiteLabel == "1";
    },
    esports2() {
      return config.esports2 == "1";
    },
  },
  beforeMount() {
    this.getMobile()
  },
  mounted() {
    if (this.$route.query.redirect) {
      this.$swal("Info", this.$t("message.login"), "info").then(result => {
        // this.$router.push("/");
      });
    }

    $("#main-carousel").on("slide.bs.carousel", function(e) {
      if (e.relatedTarget.id == "sport") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/images/ubett/ub/slider_bg.jpg");
      } else if (e.relatedTarget.id == "casino") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/images/ubett/ub/slider_casino_bg.jpg)");
      } else if (e.relatedTarget.id == "games") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/images/ubett/ub/slider_games_bg.jpg)");
      } else if (e.relatedTarget.id == "live") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/images/ubett/ub/slider_live_bg.jpg)");
      } else if (e.relatedTarget.id == "efight") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/images/ubett/ub/slider_esport_bg.jpg)");
      } else if (e.relatedTarget.id == "efight2") {
        $(".bg-landing").addClass("fadeInSlider");
        setTimeout(function() {
          $(".bg-landing").removeClass("fadeInSlider");
        }, 1000);
        $(".bg-landing").css("background-image", "url(" + config.resourceImgUrl + "/images/ubett/ub/slider_tfgaming_bg.jpg)");
      }
    });

    $(".carousel-control-next, .carousel-control-prev").click(function() {
      $(".bg-landing").removeClass("fadeInSlider");
    });

    this.$nextTick(() => {
      $(".carousel").carousel({
        interval: 5000
      });
    });
  },
  methods: {
    getImage(fn) {
      return config.getLandingUrl("ub/" + fn);
    },
    close(e) {
      switch(e) {
        case 0:
          this.isAndroid = false;
          break;
        case 1:
          this.isIOS = false;
          break;
      }
    },
    getMobile() {
      let isMobile = {
        Android: function () {
          return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
          return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
          return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
          return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
          return navigator.userAgent.match(/IEMobile/i);
        },
        any: function () {
          return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
        }
      }

      if (isMobile.iOS()) {
        this.isIOS = true
      } else {
        this.isIOS = false
      }

      if (isMobile.Android()) {
        this.isAndroid = true
      } else {
        this.isAndroid = false
      }

      if (isMobile.Windows()) {
        this.isWindows = true
      } else {
        this.isWindows = false
      }
    },
  }
};
</script>
